<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Resources</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Resources</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  href="#"
                  class="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_termination_type"
                  ><i class="fa fa-plus"></i> Add Resources</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div>
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th style="width: 30px;">#</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in resources" v-bind:key="item.id">
                      <td>{{index + 1}}</td>
                      <td>{{item.name}}</td>
                      <td>{{item.type == 1 ? 'General' : 'Custom'}}</td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown"
                            aria-expanded="false"><i class="material-icons">more_vert</i></a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item" @click="selectResource(item)"  data-toggle="modal" data-target="#edit_termination_type"><i
                                class="fa fa-pencil m-r-5"></i> Edit</a>
                            <a class="dropdown-item"  data-toggle="modal" @click="selectResource(item)" data-target="#delete_department"><i
                                class="fa fa-trash-o m-r-5"></i> Delete</a>
                          </div>
                        </div>
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Department Modal -->
        <div id="add_termination_type" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Resources</h5>
                <button
                  type="button"
                  class="close" id="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label>Resource Name <span class="text-danger">*</span></label>
                    <input
                      v-model.trim="$v.name.$model"
                      id="name"
                      name="name"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.name.$error }"
                      type="text"
                    />
                    <div
                      v-if="submitted && !$v.name.required"
                      class="invalid-feedback"
                    >
                      Name is required
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Type <span class="text-danger">*</span></label>
                    <select class="form-control" v-model.trim="$v.typeId.$model">
                      <option>Select Type</option>
                      <option :value="1">General</option>
                      <option :value="2">Custom</option>
                    </select>
                    <div
                      v-if="submitted && !$v.typeId.required"
                      class="invalid-feedback"
                    >
                      Type is required
                    </div>
                  </div>
                  <div class="form-group">
                                        <label>Upload Resource</label>
                                        <div class="custom-file" v-if="!file">
                                            <input type="file" class="custom-file-input" id="cv_upload" @change="onFilePicked">
                                            <label class="custom-file-label" for="cv_upload">Choose file</label>
                                        </div>
						                <div class="row" v-if="file">
							                <div class="col-md-6"><span>{{fileName}}</span></div>
							                <div class="col-md-6"><a class="btn btn-primary" @click="changeFile">Change File</a></div>
						                </div>
                   </div>
                  <div class="submit-section">
                    <button
                      class="btn btn-primary submit-btn"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Add Department Modal -->

        <!-- Edit Department Modal -->
        <div id="edit_termination_type" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Resources</h5>
                <button
                  type="button"
                  class="close" id="closeEdit"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>Resource Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model="resource.name"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                    <label>Type <span class="text-danger">*</span></label>
                    <select class="form-control" v-model="resource.type">
                      <option>Select Type</option>
                      <option :value="1">General</option>
                      <option :value="2">Custom</option>
                    </select>
                  </div>
                <div class="form-group">
                                        <label>Upload Resource</label>
                                        <div class="custom-file" v-if="!file">
                                            <input type="file" class="custom-file-input" id="cv_upload" @change="onFilePicked">
                                            <label class="custom-file-label" for="cv_upload">Choose file</label>
                                        </div>
						                <div class="row" v-if="file">
							                <div class="col-md-6"><span>{{fileName}}</span></div>
							                <div class="col-md-6"><a class="btn btn-primary" @click="changeFile">Change File</a></div>
						                </div>
                  </div>
                <div class="submit-section">
                  <button
                    class="btn btn-primary submit-btn"
                    @click="onPutSubmit"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Edit Department Modal -->

        <!-- Delete Department Modal -->
        <div
          class="modal custom-modal fade"
          id="delete_department"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Resources</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="onDeleteSubmit"
                        class="btn btn-primary continue-btn"
                        
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a data-dismiss="modal" id="closeDelete" class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete Department Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { skillsService } from "@/services/skillsService";
import { organizationService } from "@/services/organizationService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
  },

  data() {
    return {
      company: authenticationService.currentOfficeValue,
      name: "",
      typeId: null,
      resource: {},
      resources: [],
      submitted: false,
      loading: false,
      file: null,
			fileName: null,
      error: "",
      isCreatedSkillType: false,
      
    };
  },

  validations: {
    name: { required },
    typeId: { required },
  },

  methods: {
    onFilePicked(event) {
      			const files = event.target.files
      			this.fileName = files[0].name
				//   // console.log(this.fileName)
      			// const fileReader = new FileReader()
      			// fileReader.addEventListener('load', () => {
        		// 	this.file = fileReader.result
      			// })
      			// fileReader.readAsDataURL(files[0])
      			this.file = files[0];
			},
  clearModel() {
                this.name = "";
                this.typeId = null;
                this.file = null;
                this.fileName = ''
            },
			changeFile(){
				this.file = null
				this.fileName = ''
			},

    selectResource (item) {
      console.log(item)
      this.resource = item
    },

    getResourceDocument(file) {
      organizationService.getPolicyDocument(file).then(
        (model) => {
          let blob = new Blob([model.data], { type: model.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, model.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = model.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        },
        (error) => {
          error = error;
        }
      );
    },

    getResources () {
      skillsService.getResources(this.company.id)
          .then(
            model => { this.resources = model
            console.log(model) },
            error => { error = error }
          )
    },

    onSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      //console.log(this.name)
      skillsService.addResource(this.name, this.typeId, this.file, this.company.id).then(
        (d) => {
          this.resources = d;
          this.clearModel();
          $('#close').click();
        },
        (error) => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onPutSubmit() {
      this.loading = true;
      skillsService
        .updateResource(
          this.resource.id,
          this.resource.name,
          this.resource.type,
          this.file,
          this.resource.companyId
        )
        .then(
          (d) => {
            this.resources = d;
              $('#closeEdit').click()
          },
          (error) => {
            this.error = error;
            this.loading = false;
          }
        );
    },

    onDeleteSubmit() {
      this.loading = true;
      skillsService
        .removeResource(
          this.resource.id
        )
        .then(
          (id) => {
            skillsService.getResources(this.company.id).then((r) => {
              this.resources = r;
              $('#closeDelete').click()
            });
          },
          (error) => {
            this.error = error;
            this.loading = false;
          }
        );
    },
  },

  mounted() {
    this.getResources();
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },

  name: "resources",
};
</script>


// WEBPACK FOOTER //
// src/components/settings/resources.vue